<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">信息管理></div>
      </div>
      <div class="body_content">
          <div class="writeMsg"  @click="newMsg()">
            写信息
          </div>
        <div class="divBody divBodyThree">
          <table class="table table-striped tabShow">
            <thead>
            <tr>
              <th width="12%">收件人</th>
              <th width="45%">主题</th>
              <th width="15%">定时追踪</th>
              <th width="12%" class="msg_time">时间</th>
              <th width="15%" class="mgs_action">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(msgOne, index) in msgList" :key="index">
              <td width="12%" class="tabTd_content_ellipsis tabTd_name_three" @click="lookMsgDetails(msgOne.id)" style="cursor: pointer">
                <span class="glyphicon glyphicon-envelope"></span>
                @{{msgOne.recName}}
              </td>
              <td width="45%" class="tabTd_content_ellipsis tabTd_context_three" @click="lookMsgDetails(msgOne.id)" style="cursor: pointer">
                <b>{{msgOne.title}}</b>
                <span>——</span>
                <span>{{msgOne.content}}</span>
              </td>
              <td width="12%" v-if="msgOne.iftrace == 1" class="tabTd_content_ellipsis td_closeTrack">
                <div class="guanbizhuizong" @click="closeTrackId = msgOne.id;closeTrack();">
                  <span>关闭追踪</span>
                </div>
              </td>
              <td width="12%" v-else class="tabTd_content_ellipsis td_closeTrack">
                未追踪
              </td>
              <td width="15%" class="tabTd_content_ellipsis tabTd_time_three">
                {{msgOne.createTime?msgOne.createTime:"未发布"}}
              </td>
              <td width="15%" class="td_option">
                <div title="发布" class="sendMsg img-tip" :class="{sendMsg_use: msgOne.status == 0}" @click="publishMsg(msgOne.id, msgOne.status)"></div>
                <div title="编辑" class="edit img-tip" :class="{edit_use: msgOne.status == 0}" @click="editMsg(msgOne.id, msgOne.status)"></div>
                <div title="删除" class="deleteMsg img-tip" :class="{deleteMsg_use: msgOne.status == 0 || msgOne.status == 1}" @click="deleteMsg(msgOne.id)"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import pageView from './pageView';
  import {getContentSize} from './mainView';

  export default {
    name: "message",
    components:{pageView},
    data() {
      return {
        //通知消息
        msgList: [],
        closeTrackId: '',
        searchParams: {
          title:'',
          all: 0,
          rows: 10,
          page:1
        },
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.loadMessageData();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.loadMessageData;
      })
    },
    methods: {
      /**
       * 加载首页数据
       */
      loadMessageData(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {queryType: true};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'notice/findPage',
          params: _searchParams
        }).then(function (msgResp) {
          //通知消息
          let msgData = msgResp.data;
          if(msgData.success){
            console.log('------------msgData:',msgData)
            this_.msgList = msgData.list;
            this_.searchParams.all = msgData.totalPage;
            this_.searchParams.page = 1;
          }
        });
      },
      /**
       * 关闭追踪
       */
      closeTrack(){
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'notice/editIftrace',
          data: {
            id: this_.closeTrackId,
            iftrace: 0
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.loadMessageData();
          }
        });
      },
      /**
       * 发布
       */
      publishMsg(id, status){
        let this_ = this;
        if(status == 0){
          "确定发布".showConfirm(function () {
            schoolAxios({
              method: 'put',
              url: 'notice/editStatus',
              data: {
                id: id,
                status: 1
              }
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                "发布成功".showMessage();
                this_.loadMessageData();
              }else {
                "发布失败".showMessage();
              }
            });
          });
        }
      },
      /**
       * 编辑信息跳转路由
       */
      editMsg(id, status){
        let this_ = this;
        if(status == 0){
          //保存或修改

          this_.$store.set("msgDetailsId", id);

          //路由跳转
          this_.$router.push({
            name: 'WriteMsg',
          });
        }
      },
      /**
       * 删除
       */
      deleteMsg(id){
        let this_ = this;
        "点击确定，会造成消息记录的丢失！".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'notice/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.loadMessageData();
            }else {
              "删除失败".showMessage();
            }
          });
        });
      },
      /**
       * 查看信息详情
       */
      lookMsgDetails(msgId){
        let this_ = this;
        //保存或修改

        this_.$store.set("msgDetailsId", msgId);
        //路由跳转
        this_.$router.push({
          name: 'MessageDetails',
        });
      },
      newMsg(){
        let this_ = this;
        this_.$store.set("msgDetailsId", "");
        this_.$router.push({name: 'WriteMsg'})
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/message.css";
</style>



// WEBPACK FOOTER //
// src/components/message.vue